import React, {  Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import ChangeZipCode from '../PostLogin/common/changeZipCode';

class AvailabilityDetailsOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			availability: null
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog && this.props.handleDialog('AvailabilityDetailsOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
		const self = this;
		self.setState({
			availability: self.props.availability,
			showDialog: self.props.showDialog
		});
    }

    render() {
        const self = this;
		const { availability } = this.state;
        const { saveCustomADC, customADC, getShippingAddressesDetails, acceptNumbersOnly, saveCustomZipCode, customZipCode } = self.props;
        const { product } = self.props.state;
        let partAvailabilityData, isPartNotAvailableOnRequestedDate;

        if (self.props.isGEAPartsSalesAgreementSelected() && product && product.productSpecs && product.productSpecs.responseObject && product.productSpecs.responseObject.partAccessory) {
            isPartNotAvailableOnRequestedDate = availability && availability.availableQuantity >= 1410065408;
            partAvailabilityData = availability && {
                    availableQuantity: availability.availableQuantity,
                    warehouseCode: availability.sourceOrganizationCode && availability.sourceOrganizationCode.split(':').at(-1),
                    eta: availability.arrivalDate,
                    availabilityMessage: isPartNotAvailableOnRequestedDate ? 'BACKORDER' : '',
                    errorCode: availability.errorCode
                };
        }

        return (
            <div className={"overlayDialog "+(this.state.showDialog && this.state.availability?"visible":"hide")} id="availabilityDetailsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Availability Details</h2>
                    {partAvailabilityData ? 
                    <table className="dataTable availabilityDetailsTable">
                        <tbody>
                            <tr>
                                <td>Quantity Available:</td>
                                <td>{isPartNotAvailableOnRequestedDate ? "0 (Backorder)" : partAvailabilityData.availableQuantity}</td>
                            </tr>
                            <tr>
                                <td>Warehouse:</td>
                                <td>{partAvailabilityData.warehouseCode}</td>
                            </tr>
                            <tr>
                                <td>ETA:</td>
                                <td>{isPartNotAvailableOnRequestedDate && partAvailabilityData.eta && moment(partAvailabilityData.eta).format('MM/DD/YYYY')}</td>
                            </tr>
                        </tbody>
                    </table> :
                    <React.Fragment>
                        <ChangeZipCode
                        saveCustomADC={saveCustomADC}
                        customADC={customADC}
                        selectedAccount={self.props.state.user.selectedAccount}
                        getShippingAddressesDetails={getShippingAddressesDetails}
                        acceptNumbersOnly={acceptNumbersOnly}
                        handleSelectZipCode={saveCustomZipCode}
                        zipCode={customZipCode}
                        disableLink={ true }
                        typeOfAccount={self.props.getSelectedAccountType()}
                        showInStockFilter={false}
                        />
                        <table className="dataTable availabilityDetailsTable">
                            <tbody>
                                <tr>
                                    <td>Quantity Available:</td>
                                    <td>{availability && availability.responseObject && availability.responseObject[0].availableQty}</td>
                                </tr>
                                <tr>
                                    <td>Next Avail:</td>
                                    <td>{availability && availability.responseObject && availability.responseObject[0].intransitQty}</td>
                                </tr>
                                <tr>
                                    <td>ETA:</td>
                                    <td>{availability && availability.responseObject && availability.responseObject[0].etaDate}</td>
                                </tr>
                            </tbody>
                        </table>
                    </React.Fragment>}
                 </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

AvailabilityDetailsOverlayDialog = connect(mapStateToProps)(AvailabilityDetailsOverlayDialog);
export default AvailabilityDetailsOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/availabilityDetailsOverlayDialog.js